import { ExpertReview, KnowledgeUnit } from '../../types'

export interface ConfusionMatrixResult {
  labels: string[]
  matrix: number[][] // matrix[llmIdx][expertIdx]
  total: number
}

/**
 * Build a confusion matrix: LLM proposed_type (rows) vs expert corrected type (cols).
 */
export function confusionMatrix(
  kus: KnowledgeUnit[],
  reviews: ExpertReview[],
  correctnessDimension: string,
  correctedTypeDimension: string,
  taxonomyTypes: string[],
): ConfusionMatrixResult {
  const reviewByKU = new Map<string, ExpertReview>()
  for (const r of reviews) reviewByKU.set(r.ku_id, r)

  const labels = taxonomyTypes
  const labelIdx = new Map(labels.map((l, i) => [l, i]))
  const matrix = labels.map(() => labels.map(() => 0))
  let total = 0

  for (const ku of kus) {
    const review = reviewByKU.get(ku.id)
    if (!review) continue

    const llmType = ku.proposed_type || 'unclear'
    const legacy = review.responses as unknown as Record<string, string | boolean | null>
    const correctness = legacy[correctnessDimension]
    const correctedType = legacy[correctedTypeDimension] as string | null
    const expertType = correctness === 'incorrect' && correctedType ? correctedType : llmType

    const ri = labelIdx.get(llmType)
    const ci = labelIdx.get(expertType)
    if (ri !== undefined && ci !== undefined) {
      matrix[ri][ci]++
      total++
    }
  }

  return { labels, matrix, total }
}
